import * as CL from '@design-system/component-library';
import { Link, generatePath } from 'react-router';
import { dsClass } from '../../common/constants/dsClasses.js';
import { getElisaIdChangePasswordUrl, paths } from '../../common/constants/pathVariables.js';
import { changePasswordMsg, myAccountMsg, nameMsg, t, userDetailsMsg } from '../../common/i18n/index.js';
import { IdentityProvider } from '../../generated/api/models.js';
import { useConfig } from '../../public/site/ConfigProvider';
import { isElisaIdV3Enabled } from '../../public/site/authUtils.js';
import { Grid } from '../Grid/Grid.js';
import type { AuthenticatedUser } from '../../public/site/authState';
import type { JSX } from 'react';

import './MyAccountDetails.scss';

export interface MyAccountDetailsProps {
  authenticatedUser?: AuthenticatedUser;
}

export const MyAccountDetails = ({ authenticatedUser }: MyAccountDetailsProps): JSX.Element => {
  const { classicSiteUrl: classicBaseUrl, consumerMobiilivarmenneUrl } = useConfig();
  const isElisaIdUser = isElisaIdV3Enabled() && authenticatedUser?.identityProvider === IdentityProvider.ELISA_ID;
  const changePasswordUrl = isElisaIdUser
    ? consumerMobiilivarmenneUrl && getElisaIdChangePasswordUrl(consumerMobiilivarmenneUrl)
    : `${classicBaseUrl}/omat-tiedot`;

  const displayName = authenticatedUser ? `${authenticatedUser.firstName} ${authenticatedUser.lastName}` : '';
  const descriptionItems = [
    {
      title: t.PNS1(nameMsg),
      description: displayName,
    },
  ];

  return (
    <Grid className="my-account-details">
      <h3>{t.SEBD(myAccountMsg)}</h3>
      <CL.Description items={descriptionItems} className="wide-description" />
      <Link
        to={`${generatePath(paths.COMPANY_INFO_CONTACT, { contactMasterId: authenticatedUser?.contact?.contactMasterId ?? '' })}?mdmId=${authenticatedUser?.mdmId ?? ''}`}
        className={dsClass.LINK}
      >
        {t.T1WX(userDetailsMsg)}
      </Link>
      <div className={dsClass.MARGIN_TOP_6}>
        <CL.Button
          key="edit-in-classic"
          color="light"
          iconPosition="right"
          icon={<CL.Icon icon="external-link" color="blue-800" />}
          className="edit-in-classic"
          disabled={!changePasswordUrl}
          onClick={() => changePasswordUrl && window.open(changePasswordUrl, '_blank')}
        >
          {t.R2MM(changePasswordMsg)}
        </CL.Button>
      </div>
    </Grid>
  );
};
